import { ShortUrl } from '@air/api';
import { type Board } from '@air/api/types';
import { skipToken, useQuery } from '@tanstack/react-query';
import isObject from 'lodash/isObject';

export const PUBLIC_BOARD_STATS_KEY = 'PUBLIC_BOARD_STATS';

export type PublicBoardStatsKey = [typeof PUBLIC_BOARD_STATS_KEY, PublicBoardStatsParams];

export const getPublicBoardStatsKey = (params: PublicBoardStatsParams) => {
  return [PUBLIC_BOARD_STATS_KEY, params];
};

export const isPublicBoardStatsKey = (key: unknown): key is PublicBoardStatsKey => {
  return Array.isArray(key) && key[0] === PUBLIC_BOARD_STATS_KEY && isObject(key[1]);
};

export type PublicBoardStatsParams = Parameters<typeof ShortUrl.getStatsByShortId>[2] & {
  shortId: string | undefined;
  boardId: Board['id'] | undefined;
};

export type PublicBoardStatsOptions = {
  enabled?: boolean;
};

export const usePublicBoardStats = (params: PublicBoardStatsParams, options?: PublicBoardStatsOptions) => {
  const shortId = params.shortId;
  const boardId = params.boardId;

  return useQuery({
    queryKey: getPublicBoardStatsKey(params),
    queryFn: shortId && boardId ? () => ShortUrl.getStatsByShortId(shortId, boardId, params) : skipToken,
    enabled: !!shortId && !!boardId && options?.enabled,
  });
};
